import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "existingInvestorRow",
    "searchInput",
    "newInvestorRow",
    "newInvestorsContainer",
    "newEmail",
    "selectAllCheckbox",
    "investorCheckbox",
    "submitButton"
  ]

  connect() {
    this.updateSubmitButtonState()
  }

  filterInvestors(event) {
    const searchTerm = event.target.value.toLowerCase()

    this.existingInvestorRowTargets.forEach((row) => {
      const investorName = row.dataset.investorName

      if (investorName && investorName.includes(searchTerm)) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }

  addNewInvestor() {
    const template = this.newInvestorRowTarget.cloneNode(true)

    // Clear values in cloned template
    const emailInput = template.querySelector('[data-fund-investors-form-target="newEmail"]')
    if (emailInput) {
      emailInput.value = ""
      // Add event listener for new email input
      emailInput.addEventListener('input', () => this.emailChanged())
    }

    // Add remove button to the template
    const removeBtn = document.createElement('button')
    removeBtn.type = 'button'
    removeBtn.className = 'mt-2 text-red-600 hover:text-red-800 text-sm font-medium'
    removeBtn.textContent = '✕ Remove'
    removeBtn.addEventListener('click', () => {
      template.remove()
      this.updateSubmitButtonState()
    })

    template.appendChild(removeBtn)

    this.newInvestorsContainerTarget.appendChild(template)

    // Focus the new email input
    if (emailInput) emailInput.focus()
  }

  toggleSelectAll(event) {
    const isChecked = event.target.checked

    // Only toggle visible checkboxes (respects search filter)
    this.investorCheckboxTargets.forEach((checkbox) => {
      const row = checkbox.closest('tr')
      if (row && row.style.display !== 'none') {
        checkbox.checked = isChecked
      }
    })

    this.updateSubmitButtonState()
  }

  updateSelectAllState() {
    // Update select all checkbox state based on individual checkboxes
    if (!this.hasSelectAllCheckboxTarget) return

    const visibleCheckboxes = this.investorCheckboxTargets.filter((checkbox) => {
      const row = checkbox.closest('tr')
      return row && row.style.display !== 'none'
    })

    if (visibleCheckboxes.length === 0) {
      this.selectAllCheckboxTarget.checked = false
      this.selectAllCheckboxTarget.indeterminate = false
      return
    }

    const checkedCount = visibleCheckboxes.filter(cb => cb.checked).length

    if (checkedCount === 0) {
      this.selectAllCheckboxTarget.checked = false
      this.selectAllCheckboxTarget.indeterminate = false
    } else if (checkedCount === visibleCheckboxes.length) {
      this.selectAllCheckboxTarget.checked = true
      this.selectAllCheckboxTarget.indeterminate = false
    } else {
      this.selectAllCheckboxTarget.checked = false
      this.selectAllCheckboxTarget.indeterminate = true
    }

    this.updateSubmitButtonState()
  }

  updateSubmitButtonState() {
    if (!this.hasSubmitButtonTarget) return

    const hasInvestorData = this.hasAtLeastOneInvestor()

    if (hasInvestorData) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
      this.submitButtonTarget.title = ''
    } else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
      this.submitButtonTarget.title = 'Select at least one investor or enter an email to continue'
    }
  }

  hasAtLeastOneInvestor() {
    // Check if any existing investor checkbox is selected
    const hasSelectedInvestor = this.investorCheckboxTargets.some(checkbox => checkbox.checked)
    if (hasSelectedInvestor) return true

    // Check if any new investor email is filled in
    const hasNewEmail = this.newEmailTargets.some(input => input.value && input.value.trim() !== '')
    return hasNewEmail
  }

  // Called when email inputs change
  emailChanged() {
    this.updateSubmitButtonState()
  }
}
